import Birthday1 from "./cards/Birthday1";
import Birthday2 from "./cards/Birthday2";
import Birthday3 from "./cards/Birthday3";
import Funny1 from "./cards/Funny1";
import Funny2 from "./cards/Funny2";
import Funny3 from "./cards/Funny3";
import Funny4 from "./cards/Funny4";
import Funny5 from "./cards/Funny5";
import Funny6 from "./cards/Funny6";
import Funny7 from "./cards/Funny7";
import Valentines1 from "./cards/Valentines1";
import Valentines2 from "./cards/Valentines2";
import Xmas1 from "./cards/Xmas1";
import Xmas2 from "./cards/Xmas2";
import Custom1 from "./cards/Custom1";
import Custom2 from "./cards/Custom2";
import Custom3 from "./cards/Custom3";

export const cards = {
  birthday1: {
    id: "birthday1",
    type: "birthday",
    component: <Birthday1 />,
  },
  birthday2: {
    id: "birthday2",
    type: "birthday",
    component: <Birthday2 />,
  },
  birthday3: {
    id: "birthday3",
    type: "birthday",
    component: <Birthday3 />,
  },
  xmas1: {
    id: "xmas1",
    type: "xmas",
    component: <Xmas1 />,
  },
  xmas2: {
    id: "xmas2",
    type: "xmas",
    component: <Xmas2 />,
  },
  valentines1: {
    id: "valentines1",
    type: "valentines",
    component: <Valentines1 />,
  },
  valentines2: {
    id: "valentines2",
    type: "valentines",
    component: <Valentines2 />,
  },
  funny1: {
    id: "funny1",
    type: "funny",
    component: <Funny1 />,
  },
  funny2: {
    id: "funny2",
    type: "funny",
    component: <Funny2 />,
  },
  funny3: {
    id: "funny3",
    type: "funny",
    component: <Funny3 />,
  },
  funny4: {
    id: "funny4",
    type: "funny",
    component: <Funny4 />,
  },
  funny5: {
    id: "funny5",
    type: "funny",
    component: <Funny5 />,
  },
  funny6: {
    id: "funny6",
    type: "funny",
    component: <Funny6 />,
  },
  funny7: {
    id: "funny7",
    type: "funny",
    component: <Funny7 />,
  },
  custom1: {
    id: "custom1",
    type: "custom",
    component: <Custom1 />,
  },
  custom2: {
    id: "custom2",
    type: "custom",
    component: <Custom2 />,
  },
  custom3: {
    id: "custom3",
    type: "custom",
    component: <Custom3 />,
  },
};
